import { BaixaCobranca } from '../../../model/baixa-cobranca.model';

import { Component, OnInit, ViewChild } from "@angular/core";
import { BnLoadingService, MessageChannelService, messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnAlertsService } from "@bndes/bndes-ux4/bn-alerts";
import moment from "moment";
import { TarefaFgenergiaService } from './tarefas-fgenergia.service';
import { NgForm } from '@angular/forms';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-tarefas-fgenergia',
    templateUrl: './tarefas-fgenergia.component.html',
    styleUrls: ['./tarefas-fgenergia.component.scss'],
    standalone: false
})
export class TarefasFgenergiaComponent implements OnInit {

  public cnpjCliente: string;
  public esco: boolean = false;
  public anoMesBuscaSaldoContaRecursosGarantia: string | Date;

  constructor(
    private tarefaFgenergiaService: TarefaFgenergiaService,
    private datePipe: DatePipe,
    private messageService: MessageChannelService,
    private alertService: BnAlertsService,
    private loadingService: BnLoadingService,) {
  }

  ngOnInit(): void {

  }
  onSubmit(form: NgForm) {
     
  }

  @ViewChild('f') questionarioForm: NgForm;

  public criarQuestionario() {
    this.loadingService.bloqueiaTela();
    this.tarefaFgenergiaService.criarQuestionario(this.cnpjCliente, this.esco).subscribe((questionario) => {
      this.messageService.addMessage({
        title: 'Sucesso',
        type: 'CRUD_OPERATION',
        level: messageLevel.SUCCESS,
        message: 'Questionario criado com sucesso. Token: ' + questionario.token
      })
      this.loadingService.liberaTela();
    })
  }

  public cancelarQuestionario() {
    this.loadingService.bloqueiaTela();
    this.tarefaFgenergiaService.cancelarQuestionario(this.questionarioForm.value.cnpjCliente).subscribe(() => {
      this.messageService.addMessage({
        title: 'Sucesso',
        type: 'CRUD_OPERATION',
        level: messageLevel.SUCCESS,
        message: 'Todas as operacoes do beneficiario foram canceladas com sucesso.'
      })
      this.loadingService.liberaTela();
    })
  }

  onClear() {
    this.questionarioForm.reset();
  }

  public limparParametrosQuestionario() {
    this.cnpjCliente = null;
    this.esco = null;
  }

  public buscarSaldoContaRecursosCoberturaGarantia() {

    if(this.anoMesBuscaSaldoContaRecursosGarantia == null) {
      this.alertService.alertaErro('Erro', 'Preencha primeiramente a data de referência para consulta do saldo');
      return;
    } 

    this.loadingService.bloqueiaTela();
    console.log(this.anoMesBuscaSaldoContaRecursosGarantia);

    let anoMesRefBuscaSaldoContaRecursosGarantia:string = this.datePipe.transform(this.anoMesBuscaSaldoContaRecursosGarantia, 'yyyyMM');

    this.tarefaFgenergiaService.buscarSaldoContaRecursosCoberturaGarantia(anoMesRefBuscaSaldoContaRecursosGarantia).subscribe(saldoConta => {
      this.messageService.addMessage({
        title: 'Sucesso',
        type: 'CRUD_OPERATION',
        level: messageLevel.SUCCESS,
        message: 'Saldo da conta de recursos de garantia obtido do SAP: ' + saldoConta
      })
      this.loadingService.liberaTela();
    })
  }

  public atualizarLimite() {
    this.loadingService.bloqueiaTela();
    this.tarefaFgenergiaService.atualizarLimiteContratacao().subscribe(valorLimite => {
      this.messageService.addMessage({
        title: 'Sucesso',
        type: 'CRUD_OPERATION',
        level: messageLevel.SUCCESS,
        message: 'Limite do FGEnergia atualizado com sucesso. Valor do limite atualizado: ' + valorLimite
      })
      this.loadingService.liberaTela(); }, (error) => { this.loadingService.liberaTela(); });
    }
  }
